// Polyfills
import '@babel/polyfill';
import 'app/common/polyfills/element-closest';
import 'event-source-polyfill/src/eventsource';
import 'intersection-observer';
import 'intl';
import 'url-polyfill';
import 'app/scripts/vendor/ChildNode.remove.polyfill'; // custom addition on line 12: if (this.parentNode !== null)
import 'whatwg-fetch';

import 'app/scripts/init';

// Extend jQuery with the format and formatHtml methods
import 'app/scripts/lib/jquery-localize';

import React from 'react';
import ReactDOM from 'react-dom';

import API from 'app/gamma/src/api';
import { defaultStore } from 'app/gamma/src/defaultStore';
import { setMember } from 'app/gamma/src/modules';
import { loadMemberProfile } from 'app/gamma/src/modules/loaders/load-member';
import experiment from 'app/gamma/src/util/experiments';

import Storage from 'app/common/lib/storage';
import { memberId } from '@trello/session-cookie';
import { Chrome } from 'app/scripts/views/chrome/Chrome';
import { recordFeatureFlags } from 'app/scripts/init/record-feature-flags';
import { client, ApolloCacheHydrator } from '@trello/graphql';
import ModelCache from 'app/scripts/db/model-cache.coffee';
import { featureFlagClient } from '@trello/feature-flag-client';

// Redux store setup, included here so that we can safely assume it's present early
API.setStore(defaultStore);
experiment.setStore(defaultStore);
Storage.setStore(defaultStore);
defaultStore.dispatch(setMember({ idMe: memberId }));
defaultStore.dispatch(loadMemberProfile(memberId));

// Initialize the ApolloCacheHydrator and wire it up to real-time feature flag
// changes just to be safe
const hydratorFeatureFlag = 'fep.apollo_cache_hydrator';
const apolloCacheHydrator = new ApolloCacheHydrator({
  modelCache: ModelCache,
  apolloClient: client,
});
const hydratorEnabled = featureFlagClient.get(hydratorFeatureFlag, false);
if (hydratorEnabled) {
  apolloCacheHydrator.start();
}
featureFlagClient.on(hydratorFeatureFlag, (isEnabled) => {
  if (isEnabled) {
    apolloCacheHydrator.start();
  } else {
    apolloCacheHydrator.stop();
  }
});

ReactDOM.render(<Chrome />, document.getElementById('chrome-container'));

// Write current feature flags to localStorage so we can send them along with
// any support requests
recordFeatureFlags();
